import { createAction } from "redux-actions"

import { CLOSE_SUCCESS_NOTIFICATION } from "../constants/ActionTypes"

export const deleteSuccessNotification = createAction(
  CLOSE_SUCCESS_NOTIFICATION
)
